module.exports = __webpack_public_path__ + "img/richard-march-hoe.4aa66cc9.png";